<template>
<!--体验官招募令报名页面-->
  <div class="container">
    <div class="bg"></div>
    <div class="detail">
      <mt-field placeholder="请填写您的手机号" v-model="mobileNumber" type="tel" class="mobile" @blur.native.capture="mobileValidation"></mt-field>
      <mt-field placeholder="请输入验证码" v-model="experienceData.form.identifyCode" class="code">
        <mt-button @click="getCode" class="codeTips" type="default">{{getCodeData.codeName}}</mt-button>
      </mt-field>
      <div class="checkout" style="padding-top: 2px;">
        <span v-show="getCodeData.checkStatus">{{getCodeData.checkOutValue}}</span>
      </div>
      <mt-button :class="experienceData.disabled ? 'disBtn':'btn'" @click="submit" :disabled="experienceData.disabled">我要报名</mt-button>
      <div class="rule">
        <div class=title>
          <span class="center">活动规则说明</span>
        </div>
        <div class="content">
          <div v-for="item in experienceData.content" :key="item.index">
            <p>{{item.title}}</p>
            <p>{{item.value}}</p>
          </div>
        </div>
      </div>
      <div class="rule">
        <div class=title>
          <span class="center">温馨提示</span>
        </div>
        <div class="content">
          <p class="tips">&nbsp;</p>
          <div v-for="item in experienceData.ruleContent" :key="item.index">
            <p >{{item.value}}</p>
          </div>
        </div>
      </div>
      <div class="sponsor">
        <p>活动主办方：上汽团委|享道出行</p>
      </div>
    </div>
    <div class="fuzzy" ref="modal" v-if="getCodeData.isImgCode">
      <div class="promt">
        <div class="title"><p>输入验证码</p></div>
        <div class="imgCode">
          <mt-field placeholder="请输入右侧验证码" v-model="getImgCodeData.form.imgCode" class="identifyCode">
            <img :src="getImgCodeData.imgdata" height="45px" width="100px" @click="changeImgCode">
          </mt-field>
        </div>
        <div class="test">
          <span v-if="getImgCodeData.visible">{{getImgCodeData.checkVal}}</span>
        </div>
        <div class="btn">
          <mt-button  class="default" @click="getCodeData.isImgCode = false">取消</mt-button>
          <mt-button class="primary" @click="confirmCode">确认</mt-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import {
  // 获取验证码
  getCodeRequest,
  // 注册登录
  loginRequest,
  // 获取图片验证码
  getImgCodenRequest,
  // 验证图片验证码
  confirmImgCodenRequest
} from '@/data/api/common/Login/Login.js'
import Cookie from '@/common/utils/Cookie.js'
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
import { validateMobile } from '@/common/validate/validate.js'
import { setUserId } from '@/common/utils/cookieHandler'

export default {
  name: 'ExperiencePage',
  data () {
    return {
      experienceData: {
        disabled: true,
        form: {
          mobile: '',
          // 验证码
          identifyCode: '',
          // 图片验证码ID
          imgId: '',
          // 图片验证码
          imgCode: '',
          source: 'marketing'
        },
        content: [
          {title: '1.  体验官报名时间', value: '11月13日-12月8日'},
          {title: '2.  活动介绍', value: '享道出行首批出行体验官招募进行时，专享所有特权，只需一键报名，即可抢先体验自在出行。'},
          {title: '3.  您的特权', value: '享道出行全新服务抢先体验：免费领取300元专属体验礼包（10张30元立减券）。'}
        ],
        ruleContent: [
          {value: '1.  所有参与用户完全有权自愿选择是否参加此活动，一旦参加本活动的任何一个环节或全部，即视为已完全了解并完全接受包括本规则及其解释在内的各项条款；'},
          {value: '2.  受邀扫码即可参与本次活动。'},
          {value: '3.  参与活动过程中，如果发现参加者在活动中使用任何不正当的手段参加活动（如批量注册等），享道出行有权在不事先通知的前提下取消其参加活动资格；'},
          {value: '4.  本次活动中发放的优惠券（“30元立减券”）仅限于活动参加者使用其注册的享道出行账户结算车费时使用。该等抵扣券不可提现，不可转让，活动参加者不得将优惠券赠送、出售给任何第三人使用。一经发现，享道出行有权取消您已领取的优惠券的使用资格；'},
          {value: '5.  上海赛可出行科技服务有限公司在适用法律所允许的最大范围内对本次活动拥有解释权。'},
        ]

      },
      getCodeData: {
        form: {
          mobile: '',
          // 司机或乘客 1乘客 2司机
          userType: 1,
          // 图片验证码id
          imgId: '',
          // 图片验证码
          imgCode: '',
          // 使用场景
          templateCode: '0002',
          source: 'marketing'
        },
        codeName: '获取验证码',
        btnCode: true,
        // 校验内容
        checkOutValue: '',
        // 60秒到倒计时
        time: 60,
        // 校验状态判断
        checkStatus: false,
        // 图片验证码显示判断
        isImgCode: false,
        errCode: ''
      },
      // 图片验证码
      getImgCodeData: {
        imgdata: '',
        checkVal: '',
        visible: false,
        form: {
          imgId: '',
          imgCode: ''
        }
      },
      mobileNumber:'',
      validatorFlag:false
    }
  },
  mounted () {
    UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: false})
  },
  methods: {
    // 获取验证码
    getCode: function () {
      if(!this.getCodeData.btnCode) return
      UpdateLogData({path: this.$route.path, action: 'sendCode', hasRedPacket: false})
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      this.getCodeData.form.mobile = this.mobileNumber.split(" ").join("")
      if (!this.getCodeData.btnCode) {
        return false
      } else {
        if (this.getCodeData.errCode === -200140) {
          this.getCodeData.isImgCode = true
          this.getImgCodeData.form.imgCode = ''
          this.getImgCode()
        } else {
          if (!(validateMobile(this.getCodeData.form.mobile).status)) {
            this.getCodeData.checkStatus = true
            this.getCodeData.checkOutValue = '手机号格式有误'
          } else {
            this.getCodeData.checkStatus = false
            this.getCodeData.btnCode = false
            this.$route.query.resource ? this.getCodeData.form.resource = this.$route.query.resource : ''
            this.$mint.Indicator.open({
              text: '加载中...',
              spinnerType: 'fading-circle'
            })
            this.timeOut(this.getCodeData)
            getCodeRequest(this.getCodeData.form).then((response) => {
              this.getCodeData.form.imgId = ''
              this.getCodeData.form.imgCode = ''
            }).catch((response) => {
              this.getCodeData.checkStatus = true
              this.getCodeData.errCode = response.data.errCode
              this.getCodeData.checkOutValue = response.data.errMsg
              this.getCodeData.btnCode = true
              // 提示账号有风险时弹出图形验证码弹窗
              if (response.data.errCode === -200140) {
                this.getCodeData.isImgCode = true
                this.getImgCodeData.form.imgCode = ''
                this.getImgCode()
              }
            }).finally(() => {
              this.$mint.Indicator.close()
            })
          }
        }
      }
    },
    // 获取图片验证码
    getImgCode: function () {
      this.$mint.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      getImgCodenRequest().then((response) => {
        console.log(response)
        this.getImgCodeData.imgdata = 'data:image/png;base64,' + response.imgData
        this.getImgCodeData.form.imgId = response.imgId
        this.getCodeData.form.imgId = response.imgId
      }).catch(() => {}).finally(() => {
        this.$mint.Indicator.close()
      })
    },
    // 改变图片验证码
    changeImgCode: function () {
      this.getImgCode()
    },
    // 确认图片验证码
    confirmCode: function () {
      this.$mint.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      confirmImgCodenRequest(this.getImgCodeData.form).then((response) => {
        this.getCodeData.isImgCode = false
        this.getImgCodeData.visible = false
        this.getCodeData.errCode = 0
        this.getCodeData.form.imgCode = this.getImgCodeData.form.imgCode
      }).catch((response) => {
        this.getImgCodeData.visible = true
        this.getImgCodeData.checkVal = response.data.errMsg
      }).finally(() => {
        this.$mint.Indicator.close()
      })
    },
    // 倒计时
    timeOut: function (obj) {
      if (obj.timer) {
        clearInterval(obj.timer)
      }
      obj.btnCode = false
      obj.timer = setInterval(function () {
        obj.codeName = obj.time + 's重新获取'
        obj.time--
        if (obj.time <= 0) {
          obj.codeName = '获取验证码'
          clearInterval(obj.timer)
          obj.btnCode = true
          obj.time = 60
        }
      }, 1000)
    },
    // 我要报名函数
    submit: function () {
      this.getCodeData.form.mobile = this.mobileNumber.split(" ").join("")
      UpdateLogData({path: this.$route.path, action: 'login', hasRedPacket: false})
      // let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
      this.experienceData.form.mobile = this.getCodeData.form.mobile
      this.$route.query.resource ? this.experienceData.form.resource = this.$route.query.resource : ''
      // if (this.experienceData.form.mobile === '') {
      //   this.getCodeData.checkStatus = true
      // } else
      this.$mint.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      loginRequest(this.experienceData.form).then((res) => {
        setUserId(res.uid)
        const TokenKey = 'Admin-Token'
        Cookie.set(TokenKey, res.accessToken)
        if (res.registration === false) {
          // window.location.href = window.location.pathname + '#/experienceOldExplist' + `?channel=${this.$route.query.channel}`
          window.location.href = window.location.pathname + '#/experienceOldExplist'
          document.title = '首席体验官招募令'
        } else {
          // window.location.href = window.location.pathname + '#/experienceApply' + `?channel=${this.$route.query.channel}`
          window.location.href = window.location.pathname + '#/experienceExplist'
          document.title = '首席体验官招募令'
        }
      }).catch((res) => {
        this.getCodeData.checkStatus = true
        this.getCodeData.checkOutValue = res.data.errMsg
        this.getCodeData.errCode = res.data.errCode
        // // 提示账号有风险时弹出图形验证码弹窗
        // if (res.data.errCode === -200140) {
        //   this.getCodeData.isImgCode = true
        //   this.getImgCode()
        // }
        // 登录失败 删除token
        Cookie.del('Admin-Token')
      }).finally(() => {
        this.$mint.Indicator.close()
      })
    },
    // 清理定时器
    clearIntervalTimer () {
      if (this.getCodeData.timer) {
        clearInterval(this.getCodeData.timer)
      }
    },
    mobileValidation(){
      this.getCodeData.form.mobile = this.mobileNumber.split(" ").join("")
      let validator = validateMobile(this.getCodeData.form.mobile)
      if (!validator.status || isNaN(this.getCodeData.form.mobile)) {
          this.validatorFlag = true
            this.getCodeData.checkStatus = true
            this.getCodeData.checkOutValue = '手机号格式有误'
      }else{
            this.getCodeData.checkStatus = false
      }      
    }    
  },
  watch: {
    'mobileNumber': function (val, oldVal) {
      if (val.length > oldVal.length) { // 文本框中输入
        if (val.length === 4 || val.length === 9) {
          this.mobileNumber = oldVal + ' ' + val[val.length-1]
        }
      } else { // 文本框中删除
        if (val.length === 9 || val.length === 4) {
          this.mobileNumber = this.mobileNumber.trim()
        }
      }
      if(this.validatorFlag) this.mobileValidation()
    },
    'experienceData.form.identifyCode': function (val, oldVal) {
      this.getCodeData.checkStatus = false
      this.experienceData.disabled = false
      if (val === '') {
        this.experienceData.disabled = true
      }
    },
    'getImgCodeData.form.imgCode': function (val, oldVal) {
      this.getImgCodeData.visible = false
    }
  },
  destroyed () {
    this.clearIntervalTimer()
  }
}
</script>
<style lang="stylus">
.container .detail .mobile{
  border:0.5px solid #E9E9EA;
  border-radius: 5px
}
.container .detail .code {
  border:0.5px solid #E9E9EA;
  border-radius: 5px
}

.code .mint-field-clear{
  padding-right:8px
}
</style>
<style scoped lang="stylus">
.container{
  width:100%;
  height:auto;
  background:linear-gradient(180deg,rgba(192,244,238,1),rgba(0,178,169,1));
  padding-bottom:10px;
  .bg{
    width:100%;
    height: 530px;
    background :url(../../assets/images/common/Group_bg.png) no-repeat;
    background-size: cover;
    background-position:center;
  }
  .detail{
    width:96%;
    height:auto;
    box-sizing:border-box;
    padding:0 15px;
    background:rgba(243,244,245,1);
    padding-top:30px;
    margin:-195px auto 0 auto;
    .mobile{
      height:50px;
      width:100%;
      font-size:16px;
      border:0.5px solid #E9E9EA;
       >>>.mint-cell-wrapper{
             background-image :none !important
           }
        >>> .mint-cell-value .mint-field-core::-webkit-input-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core::-moz-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core:-moz-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core:-ms-input-placeholder{
          color:#ccc;
        }
    }
    .code{
      height:50px;
      width:100%;
      font-size:16px;
      margin-top:15px;
      border:0.5px solid #E9E9EA;
      >>>.mint-cell-wrapper{
             background-image :none !important
           }
       >>> .mint-cell-value .mint-field-core::-webkit-input-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core::-moz-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core:-moz-placeholder{
          color:#ccc;
        }
        >>> .mint-cell-value .mint-field-core:-ms-input-placeholder{
          color:#ccc;
        }
        >>>.mint-field-other{
          border-left:1px solid #eee;
        }
      .codeTips{
        color:#00B2A9;
        float:right
        height: 26px;
        line-height: 20px;
        padding-left: 13px;
      }
      // >>>.mint-field-core{
      //   border-right:1px solid #eee;
      // }
    }
    .checkout{
      width: 100%;
      font-size:13px;
      color:#FF0000;
      height:24px;
      span{
        line-height 24px;
      }
    }
    .btn{
      height:50px;
      width:100%;
      font-size:16px;
      background:rgba(0,178,169,1);
      border-radius:5px;
      color:#fff;
      margin-top:1rem
    }
    .disBtn{
      height:50px;
      width:100%;
      font-size:16px;
      background:rgba(218,226,228,1);
      border-radius:5px;
      color:#fff;
      margin-top:1rem
    }
  .rule{
    width:100%;
    padding-top:20px;
    .title{
      color:#00B2A9
      position:relative;
      text-align:center;
      z-index:0;
      .center{
        font-size:18px;
        font-weight bold;
        background: #f3f4f5;
        padding:0 25px;
      }
      &:after{
        content: '';
        display:block;
        width:100%;
        height:1px;
        background:#00B2A9;
        left:0;
        top:50%;
        position: absolute;
        transform:translate(0,-50%);
        z-index:-1;
      }
    }
    .content{
      font-size:14px;
      color:#666;
      line-height:20px;
      .tips{
        margin-bottom:-16px
      }
      div{
        margin-top:20px;

      }
      div:nth-child(1){
        p:nth-child(2){
          color:#00B2A9
        }
      }
     }
    }
    .sponsor{
      width:100%;
      text-align center;
      font-size:12px;
      padding:20px;
      color:rgba(204,204,204,1)
    }
    >>>.mint-cell-value .mint-field-other .mint-button--default{
      background-color:transparent;
      box-shadow:none;
      font-size:16px;
    }
  }
  .fuzzy{
    width:100%;
    height:100%;
    position :fixed;
    top:0;
    background :rgba(0,0,0,0.4);
    z-index:100
    .promt{
      width:84%;
      min-height:220px;
      background :#fff;
      z-index:1000;
      border-radius :10px;
      margin:6rem 8%;
      .title{
        height: 4rem;
        text-align: center;
        line-height: 4rem;
        font-size: 16px;
        color: #333;
      }
      .imgCode{
        margin:0rem 1rem
        border-bottom:1px solid #eee;
        padding-bottom:0.3rem
        .identifyCode{
          background-image :none !important
          margin-top:1.6rem;
           >>>.mint-cell-wrapper{
             background-image :none !important
           }
        }
      }
      .test{
        font-size:13px;
        color:#FF0000;
        margin:0.5rem 1rem;
        height:22px;
      }
      .btn{
        margin-top:0.8rem;
        padding-bottom:20px;
        .default{
          width: 41%;
          margin:0 4% 0 6%
          color: #89ABA5;
          background: #fff;
          border:1px solid #89ABA5;
          font-size: 15px;
        }
        .primary{
          width: 41%;
          color: #fff;
          background: #00B2A9;
          font-size: 15px;
        }
      }
    }
  }
  .share{
    width:100%;
    height:100%;
    position :fixed;
    top:0;
    background :rgba(0,0,0,0.4);
    z-index:100
    img{
      width:100%
      display:block;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/Experience/index.vue